import SellerShared from './seller-shared';
export default SellerShared;
